import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupVendor } from "src/components/Shared/NewForms/NFLookupVendor";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupVendorInvoice } from "src/components/Shared/NewForms/NFLookupVendorInvoice";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { useTranslation } from "react-i18next";

export const ImportsDetailCustomCosts = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"customCosts"}>
                <NFLookupVendor
                    fieldName={"vendorInvoiceId"}
                    title={t("Vendor")}
                />
                <NFLookupProduct fieldName={"productId"} title={t("Product")} />
                <NFLookupVendorInvoice
                    fieldName={"vendorInvoiceId"}
                    title={t("VendorInvoice")}
                />
                <NFIntInput
                    fieldName={"quantity"}
                    title={t("Quantity")}
                    width={100}
                />
                <NFIntInput fieldName={"unit"} title={t("Unit")} width={100} />
                <NFIntInput
                    fieldName={"price"}
                    title={t("Price")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"vatRate"}
                    title={t("VatRate")}
                    width={100}
                />
                <NFIntInput fieldName={"vat"} title={t("Vat")} width={100} />
                <NFIntInput
                    fieldName={"amountWithVat"}
                    title={t("amountWithVat")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"amountRegulatedCurrency"}
                    title={t("Amount(RegulatedCurrency)")}
                />
                <NFIntInput
                    fieldName={"amountRegulatedCurrencyAdditionalDocument"}
                    title={t("AmountRegulatedCurrencyAdditionalDocument")}
                />
                <NFIntInput
                    fieldName={"coeficient"}
                    title={t("Coeficient")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"customCost"}
                    title={t("CustomCost")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"customsCostAmount"}
                    title={t("CustomCostsAmount")}
                    width={100}
                />
            </NFormTable>
        </>
    );
};
